import React from 'react'
import classNames from 'classnames'
import { Navigation } from '../../../../../index'

const AbsoluteNavigation = props => {
  const {
    content: {
      linkGroups,
      metadata: { className },
    },
    location,
  } = props

  return (
    <header
      className={classNames('page-header', {
        [`page-header--${className}`]: className,
      })}
    >
      {linkGroups.map(group => (
        <Navigation key={group.id} links={group.links} location={location} isAbsolute />
      ))}
    </header>
  )
}

export default AbsoluteNavigation
